import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function kpiCardValue(): ComponentStyle {
  return {
    componentName: 'kpiCardValue',
    variants: {
      omg: {
        color: 'transparent',
        backgroundImage:
          'linear-gradient(270.98deg,#ffcd4d -5.71%,#fa43bd 102.6%)',
        backgroundClip: 'text'
      }
    }
  };
}
